import React from "react";

const RemoveQuestionModal = ({ open, onClose, onConfirm, loading, deleted }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <div className="bg-white rounded-[16px] shadow-xl p-7 w-full max-w-[500px] mx-4 flex flex-col items-center text-center">
        {/* Title */}
        <h2 className="text-[18px] font-semibold text-[#18101C] font-outfit mb-2">
          Remove custom question?
        </h2>

        {/* Description */}
        <p className="text-[14px] text-[#71717A] font-medium font-outfit leading-relaxed mb-7">
          The selected question will be completely removed from configuration.
          This action cannot be undone.
        </p>

        {/* Buttons */}
        <div className="flex items-center gap-4 w-full justify-center">
          <button
            onClick={onClose}
            disabled={loading || deleted}
            className="w-[30%] py-[10px] px-2 rounded-[8px] border border-black/20 bg-white text-[#3F3F46] text-[14px] font-medium font-outfit hover:bg-[#F9FAFB] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            disabled={loading || deleted}
            className="w-[45%] py-[10px] rounded-[8px] border border-[rgba(226,25,25,0.4)] bg-white text-[#E21919] text-[14px] font-medium font-outfit hover:bg-[#E21919] hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {deleted ? "Removed" : loading ? "Removing..." : "Remove Question"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemoveQuestionModal;
